import { ThemeT } from '@signavio/effektif-commons'
import i18n from '@signavio/i18n'
import { useStyles } from '@signavio/ui'

function EmptyIndicator({ hintText }: { hintText?: string }) {
  const style = useStyles(defaultStyles, {}, {})

  const text = hintText ?? i18n('No matching user found')

  return <div {...style('emptyOption')}>{text}</div>
}

export default EmptyIndicator

const defaultStyles = ({ spacing }: ThemeT) => ({
  emptyHint: {
    display: 'flex',
    justifyContent: 'center',
  },

  emptyOption: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: spacing.small,
    marginTop: spacing.xsmall,
  },
})
